import { TLanguage } from "@/interfaces";
import { IDtnAuthorization } from "@/shared/dtnWeather";
import { IUserProfile, IUserSettings } from "@/shared/user";

export const REHYDRATE = "rehydrate";
export const REFRESH = "refresh";
export const INITIALIZE = "initialize";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const TOGGLE_DARK_MODE = "toggle-dark-mode";
export const UPDATE_USER_SETTINGS = "update-user-settings";
export const FOLLOW_ALARMS = "follow-alarms";
export const TOGGLE_SIDEBAR = "toggle-sidebar";
export const TOGGLE_SOURCE_DATA_NAME = "toggle-source-data-name";
export const SELECTED_VESSEL = "selected-vessel";
export const CHANGE_LANGUAGE = "change-language";
export const TOGGLE_SIDEBAR_ORDER = "toggle-sidebar-order";
export const TOGGLE_IS_OPEN_FUEL_FILTERS = "toggle-is-open-fuel-filters";
export const SET_ALARM_KEYS = "set-alarm-keys";
export const SET_DTN_AUTHORIZATION = "set-dtn-authorization";
export const DID_SHOW_WELCOME = "did-show-welcome";

export class SetDtnAuthorization {
  constructor() {}
  type = SET_DTN_AUTHORIZATION;
  payload: IDtnAuthorization;
}

export class SetAlarmKeysAction {
  type = SET_ALARM_KEYS;
  payload: {
    filterKeys: string[];
    sortKey: string;
  };
}

export class FollowAlarmKeysAction {
  type = FOLLOW_ALARMS;
  payload: {
    vesselId: string;
    alarmIds: number[];
  };
}

export class LoginAction {
  type = LOGIN;
  payload: IUserProfile;
}

export class ChangeLanguageAction {
  type = CHANGE_LANGUAGE;
  payload: TLanguage;
}

export class UpdateUserSettingsAction {
  type = UPDATE_USER_SETTINGS;
  payload: Partial<IUserSettings>;
}

export class SelectedVesselAction {
  type = SELECTED_VESSEL;
  payload: {
    name: string;
    id: string;
  };
}

export class LogoutAction {
  type = LOGOUT;
}

export class ToggleSidebarAction {
  type = TOGGLE_SIDEBAR;
}

export class ToggleDarkThemeAction {
  type = TOGGLE_DARK_MODE;
}

export class ToggleSidebarOrderAction {
  type = TOGGLE_SIDEBAR_ORDER;
}

export class ToggleFuelFiltersAction {
  type = TOGGLE_IS_OPEN_FUEL_FILTERS;
}

export class ToggleSourceDataName {
  type = TOGGLE_SOURCE_DATA_NAME;
}
